import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';

import 'hammerjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@core/core.module';
import { CoreCommonModule } from '@core/common.module';
import { CoreSidebarModule, CoreThemeCustomizerModule } from '@core/components';
import { CardSnippetModule } from '@core/components/card-snippet/card-snippet.module';
import { coreConfig } from 'app/app-config';
import { JwtInterceptor, ErrorInterceptor } from 'app/auth/helpers';
import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { SocketIoModule } from 'ngx-socket-io';
import { SocketService } from 'app/services/socket.service';
import { RegisterComponent } from './common/register/register.component';
import { ProfileComponent } from './common/profile/profile.component';
import { BillingComponent } from './common/billing/billing.component';
import { SubscriptionComponent } from './common/subscription/subscription.component';
import { ComponentsModule } from 'app/components/components.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxMaskModule } from 'ngx-mask';
import { NotAuthorizedComponent } from './common/not-authorized/not-authorized.component';
import { ErrorComponent } from './common/error/error.component';
import { LoginComponent } from './common/login/login.component';
import { ForgetPasswordComponent } from './common/forget-password/forget-password.component';
import { ResetPasswordComponent } from './common/reset-password/reset-password.component';
import { AboutUsComponent } from './common/about-us/about-us.component';
import { WallatConnectComponent } from './common/wallat-connect/wallat-connect.component';

@NgModule({
  declarations: [
    AppComponent,
    RegisterComponent,
    ProfileComponent,
    BillingComponent,
    SubscriptionComponent,
    NotAuthorizedComponent,
    ErrorComponent,
    LoginComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    AboutUsComponent,
    WallatConnectComponent
  ],
  imports: [
    SocketIoModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot(),
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,
    CardSnippetModule,
    LayoutModule,
    ContentHeaderModule,
    ComponentsModule,
    NgxPaginationModule,
    NgxMaskModule.forRoot(),
  ],

  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    SocketService
  ],
  entryComponents: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
